import request from '@/utils/request'
import qs from 'qs'

export function getSportWeeklyDes(data) {
    if (data.startDate) {
        data = qs.stringify(data)
        return request({
            url: '/sportWeekly/getSportWeeklyHistory',
            method: 'post',
            data
        })
    } else {
        data = qs.stringify(data)
        return request({
            url: '/sportWeekly/getSportWeeklyDes',
            method: 'post',
            data
        })
    }
}

export function getSportWeeklyHistory(data) {
    data = qs.stringify(data)
    return request({
        url: '/sportWeekly/getSportWeeklyHistory',
        method: 'post',
        data
    })
}

export function getSportMonthDes(data) {
    if (data.startDate) {
        data = qs.stringify(data)
        return request({
            url: '/sportWeekly/getSportMonthHistory',
            method: 'post',
            data
        })
    } else {
        data = qs.stringify(data)
        return request({
            url: '/sportWeekly/getSportMonthDes',
            method: 'post',
            data
        })
    }
}

export function checkSportYear(data) {
    data = qs.stringify(data)
    return request({
        url: '/sportWeekly/checkSportYear',
        method: 'post',
        data
    })
}

export function getSportYear(data) {
    data = qs.stringify(data)
    return request({
        url: '/sportWeekly/getSportYear',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/api/report.js